import { FormattedMessage } from 'react-intl'
import { Link, useLocation } from '@tanstack/react-router'

import { Button } from '@gto/ui/button'
import { cn } from '@gto/ui/cn'
import { Typography } from '@gto/ui/typography'

const routes = [
  {
    label: <FormattedMessage id="promo.progress.rakeRace.title" />,
    value: 'rake-race',
  },
  {
    label: <FormattedMessage id="promo.progress.allInFlipOuts.title" />,
    value: 'all-in-flip-outs',
  },
  {
    label: <FormattedMessage id="promo.progress.freeTournamentTickets.title" />,
    value: 'free-tournament-tickets',
  },
]
export const TabsLayoutNav = () => {
  const location = useLocation()

  const route = location.pathname.split('/').at(-1)

  return (
    <div className="flex flex-col gap-8">
      <div className="flex flex-col gap-6">
        <Typography
          color="primary"
          component="h1"
          variant="h3"
        >
          <FormattedMessage id="promo.progress.title" />
        </Typography>
        <Typography
          component="h2"
          variant="h6"
        >
          <FormattedMessage id="promo.progress.description" />
        </Typography>
      </div>
      <div className="flex gap-4 sm:flex-col">
        {routes.map((r, index) => (
          <Button
            // eslint-disable-next-line @eslint-react/no-array-index-key -- fixed tab nav literal, never reorders
            key={index}
            color="secondary"
            component={Link}
            href={`/promotion/august-2025/${r.value}`}
            size="large"
            variant="contained"
            className={cn(
              'min-w-[200px] border border-divider sm:flex-[1_0_100%] sm:whitespace-nowrap',
              route === r.value ? 'bg-secondary-main' : 'bg-transparent',
            )}
          >
            {r.label}
          </Button>
        ))}
      </div>
    </div>
  )
}
